import axios from 'axios'
import localforage from "localforage";
import * as apiConfig from '../config/config'
import moment from 'moment'
import {writeLog} from "./logging";
import {writeTrackLog} from "./tracking";
import {isOnline} from "./online";
import {loadAsyncLanguages, setLanguage} from "../translations/main";

export const prepareDevice = (instance) => {
  if (process.env.NODE_ENV === 'development') console.log('Sync::prepareDevice');
  return localforage.getItem('token')
    .then(function (token) {
      if (process.env.NODE_ENV === 'development') console.log('Sync:prepareDevice::stored token', token)
      if (token === null || token === undefined) return Promise.reject('No token');
      instance.$store.dispatch('setToken', token);
      let res = [];
      return window.locationStore.iterate(item => { res.push(item) }).then(() => res);
    }).then(locations => {
      if (process.env.NODE_ENV === 'development') console.log('Sync:prepareDevice::locations', locations)
      if (!locations || !locations.length) return Promise.reject('No locations found');
      instance.$store.commit('setLocations', locations);
      return localforage.getItem('language');
    }).then((lang) => {
      if (process.env.NODE_ENV === 'development') console.log('Sync:prepareDevice::language', lang)
      if (!lang) lang = 'en'
      instance.$store.commit('setLanguage', lang);
      setLanguage(lang);
      return localforage.getItem('currentDevice');
    })
    .then(function (device) {
      if (process.env.NODE_ENV === 'development') console.log('Sync:prepareDevice::currentDevice', device)
      if (device === null || device === undefined) return Promise.reject('No device');
      instance.$store.dispatch('setCurrentDevice', device);
      return localforage.getItem('currentLocation');
    })
    .then(function (location) {
      if (process.env.NODE_ENV === 'development') console.log('Sync:prepareDevice::currentLocation', location)
      if (location === null) return Promise.reject('No location');

      instance.$store.commit('setCurrentLocation', location);

      if (process.env.NODE_ENV === 'development') console.log('Sync:prepareDevice::isOnline')
      if (isOnline() && instance.currentDevice) {
        instance.syncing = true;
        instance.loadingData = true;

        return syncAndUpdate(instance);
      }

      return Promise.resolve(location);
    })
    .catch(err => console.log('Sync:prepareDevice::error', err));
};

export const syncLocalToVue = (instance) => {
  localforage.getItem('language')
    .then(value => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setLanguage()', value);
      instance.$store.commit('setLanguage', value);
      setLanguage(value);
      return localforage.getItem('activity_order');
    })
    .then(value => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setActivityOrder()', value);
      instance.$store.commit('setActivityOrder', value);
      return localforage.getItem('rows_order');
    })
    .then(value => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setRowsOrder()', value);
      instance.$store.dispatch('setRowsOrder', value);
      return localforage.getItem('rowsAsButtons');
    })
    .then(value => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setRowsAsButtons()', value);
      instance.$store.dispatch('setRowsAsButtons', value);
      return localforage.getItem('pinVisible');
    })
    .then(value => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setPinVisible()', value);
      instance.$store.dispatch('setPinVisible', value);
      return localforage.getItem('setDarkMode');
    })
    .then(value => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setDarkMode()', value);
      instance.$store.dispatch('setDarkMode', value);
      return localforage.getItem('teamsAsButtons');
    })
    .then(value => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setTeamsAsButtons()', value);
      instance.$store.dispatch('setTeamsAsButtons', value);
      return localforage.getItem('teams_order');
    })
    .then(value => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setTeamsOrder()', value);
      instance.$store.commit('setTeamsOrder', value);
      return localforage.getItem('currentDevice');
    })
    .then(value => {
      return loadAsyncLanguages(value.translations, value.language);
    })
    .then(value => {
      return instance.$store.dispatch('setEmployeesFromLocal');
    })
    .then(employees => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setEmployeesFromLocal()', employees);
      return instance.$store.dispatch('setActivitiesFromLocal');
    })
    .then(activities => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setActivitiesFromLocal()', activities);
      return instance.$store.dispatch('setRowsFromLocal');
    })
    .then(rows => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setRowsFromLocal()', rows);
      return instance.$store.dispatch('setPackagingsFromLocal');
    })
    .then(packagings => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setPackagingsFromLocal()', packagings);
      return instance.$store.dispatch('setPercentagesFromLocal');
    })
    .then(percentages => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setPercentagesFromLocal()', percentages);
      return instance.$store.dispatch('setWorkdaysFromLocal');
    })
    .then(workdays => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setWorkdaysFromLocal()', workdays);
      return instance.$store.dispatch('setTimesheetEntriesFromLocal');
    })
    .then(entries => {
      if (process.env.NODE_ENV === 'development') console.log('syncLocalToVue::setTimesheetEntriesFromLocal()', entries);
      instance.ready = true;
    });
};

export const syncLocalWorkdaysToVue = (instance) => {
  let workdays = [];

  window.workdayStore.iterate(function (value) {
    workdays.push(value)
  }).then(function () {
    instance.$store.dispatch('setWorkdays', workdays)
  })
};

export const syncLocalTimesheetsToVue = (instance) => {
  let timesheetEntries = [];

  window.timesheetStore.iterate(function (value) {
    timesheetEntries.push(value)
  }).then(function () {
    instance.$store.commit('setTimesheetEntries', timesheetEntries)
  });
};

export const syncLocalToRemote = function (instance, clear = true, inBackground = false) {
  if (instance.$store.state.debug) {
    writeLog(moment().toISOString() + "Syncing local data to remote API" + (inBackground ? ' in background': ''));
  }

  if (instance.$store.state.enableTracking) {
    writeTrackLog(moment().toISOString() + "Syncing local data to remote API" + (inBackground ? ' in background': ''));
  }

  let activities = [];
  let workdays = [];

  window.timesheetStore
    .iterate(activity => {
      if (!activity.end) {
        activity.end = new moment().toISOString();
        activity.synced = false;
      }

      if (!Object.prototype.hasOwnProperty.call(activity, 'synced') || !activity.synced) activities.push(activity);
    })
    .then(() => {
      if (instance.$store.state.debug) writeLog("Entries in local storage: " + JSON.stringify(activities));
      if (instance.$store.state.enableTracking) writeTrackLog("Entries in local storage: " + JSON.stringify(activities));

      return window.workdayStore.iterate(function (workday) {
        if ((Object.prototype.hasOwnProperty.call(workday, 'synced') && workday.synced === false) || workday.end === null) {
          if (!workday.end) workday.end = new moment().toISOString();

          workdays.push(workday);
        }
      });
    })
    .then(function () {
      if (instance.$store.getters.debug) writeLog("Workdays in local storage: " + JSON.stringify(workdays));

      return localforage.getItem('token');
    })
    .then(function (value) {
      const config = {headers: {'Authorization': 'Bearer ' + value}};

      if (instance.$store.state.enableTracking) {
        writeTrackLog("Local entries to sync in : " + JSON.stringify({
          workdays: workdays,
          activities: activities
        }));
      }

      return axios.post(apiConfig.api.current + '/import/batch', {
        workdays: workdays,
        activities: activities,
        debug: instance.$store.getters.debug
      }, config);
    })
    .then(function (response) {
      if (instance.$store.getters.debug) {
        response.data.data.device.translations = undefined;
        writeLog('synchronised with api: ' + JSON.stringify(response.data));
      }

      if (clear) {
        if (process.env.NODE_ENV === 'development') console.log('clear after sync');
        instance.$store.commit('clearWorkdays');
        instance.$store.commit('clearTimesheetEntries');
        instance.$store.commit('clearCurrentEmployee');

        if (instance.$store.state.enableTracking) writeTrackLog("Local storage cleared");
      }

      if (inBackground) {
        console.log('Synced data in background');
        if (instance.$store.getters.debug) writeLog('Forced sync in background');
        if (instance.$store.state.enableTracking) writeTrackLog('Forced sync in background');
      } else {
        if (instance.$store.getters.debug) writeLog('Forced sync in foreground');
        if (instance.$store.state.enableTracking) writeTrackLog('Forced sync in foreground');

        if (instance.$route.name !== 'pin') instance.$store.commit('setChecked', {name: 'pin'});
        else instance.$store.commit('setChecked');
      }
    })
    .catch((err) => {
      if (err.response) instance.$store.dispatch('setError', err.response.statusText);
      if (instance.$store.getters.debug) writeLog('Sync failed: ' + JSON.stringify(err.response));
      if (instance.$store.state.enableTracking) writeTrackLog('Sync failed: ' + JSON.stringify(err));
    })

};

export const syncAndUpdate = function (instance) {
  console.log('Sync:syncAndUpdate')
  let activities = [];
  let workdays = [];

  if (instance.$store.state.enableTracking) writeTrackLog('Sync and update');

  // Push local-only setting changes (e.g. activity order) to the server before
  // pulling fresh data, otherwise the incoming data would overwrite them.
  return instance.$store.dispatch('flushPendingChanges')
    .then(() => window.timesheetStore
    .iterate(activity => {
      if (!Object.prototype.hasOwnProperty.call(activity, 'synced') || activity.synced === false) activities.push(activity);
    }))
    .then(function () {
      if (instance.$store.getters.debug) writeLog("Entries in local storage: " + JSON.stringify(activities));

      return window.workdayStore.iterate(function (workday) {
        if (process.env.NODE_ENV === 'development') console.log('Sync.js: workday', workday);
        if (!Object.prototype.hasOwnProperty.call(workday, 'synced') || workday.synced === false) workdays.push(workday);
      });
    })
    .then(function () {
      if (instance.$store.getters.debug) writeLog("Workdays in local storage: " + JSON.stringify(workdays));

      return localforage.getItem('token');
    })
    .then(function (value) {
      const config = {headers: {'Authorization': 'Bearer ' + value}};

      if (instance.$store.state.enableTracking) writeTrackLog('Local items to sync: ' + JSON.stringify({
        workdays: workdays,
        activities: activities
      }));

      if (!workdays.length && !activities.length) return Promise.reject({device: instance.$store.state.currentDevice});

      return axios.post(apiConfig.api.current + '/import/batch', {workdays: workdays, activities: activities}, config);
    })
    .then(function (response) {
      if (instance.$store.getters.debug) writeLog('synchronised with api: ' + JSON.stringify(response.data));
      if (instance.$store.state.enableTracking) writeTrackLog('Sync response: ' + JSON.stringify(response.data));

      const catWorkdays = response.data.data.workdays;
      const catActivities = response.data.data.activities;

      for (let i = 0; i < catWorkdays.length; i++) {
        let updatedEntry = catWorkdays[i];

        updatedEntry.synced = true;

        if (process.env.NODE_ENV === 'development') console.log('Sync.js: updatedEntry', updatedEntry);

        window.workdayStore.setItem(updatedEntry.id.toString(), updatedEntry)
          .then(function (entry) {
            if (process.env.NODE_ENV === 'development') console.log('Sync.js: save offline', entry);

            const id = updatedEntry.old_id ? updatedEntry.old_id : updatedEntry.id;
            let localWorkday = instance.$store.getters.workdayById(id);

            if (!localWorkday) {
              if (process.env.NODE_ENV === 'development') console.log('Sync.js: no localentry');

              localWorkday = instance.$store.getters.workdayById(entry.id);
            }

            if (process.env.NODE_ENV === 'development') console.log('sync.js: local', id, entry, localWorkday);

            localWorkday.id = entry.id;
            localWorkday.location_id = entry.location_id;
            localWorkday.employee_id = entry.employee_id;
            localWorkday.start = entry.start;
            localWorkday.end = entry.end;
            localWorkday.timesheet_entries = entry.timesheet_entries;
            localWorkday.confirmed = entry.confirmed;
            localWorkday.synced = entry.synced;

            if (updatedEntry.old_id) {
              window.workdayStore.removeItem(updatedEntry.old_id);
            }
          })
      }

      for (let i = 0; i < catActivities.length; i++) {
        let updatedEntry = catActivities[i];

        updatedEntry.packaging = updatedEntry.packaging_id;
        delete updatedEntry.packaging_id;

        updatedEntry.synced = true;

        window.timesheetStore.setItem(updatedEntry.id.toString(), updatedEntry)
          .then(function (entry) {
            let localEntry = instance.$store.getters.timesheetEntryById(entry.old_id);

            if (!localEntry) localEntry = {};

            localEntry.id = entry.id;
            localEntry.location_id = entry.location_id;
            localEntry.employee_id = entry.employee_id;
            localEntry.workday_id = entry.workday_id;
            localEntry.type = entry.type;
            localEntry.start = entry.start;
            localEntry.end = entry.end;
            localEntry.activity_id = entry.activity_id;
            localEntry.packaging = entry.packaging;
            localEntry.row = entry.row;
            localEntry.row_id = entry.row_id;
            localEntry.row_status = entry.row_status;
            localEntry.row_percentage = entry.row_percentage;
            localEntry.amount = entry.amount;
            localEntry.on_hold = entry.on_hold;
            localEntry.synced = entry.synced;

            if (updatedEntry.old_id) window.timesheetStore.removeItem(updatedEntry.old_id);
          })
      }

      if (response.data.data.device) {
        instance.$store.dispatch('setCurrentDevice', response.data.data.device);

        if (instance.$store.state.overrideLocal) {
          instance.$store.commit('setActivityOrder', response.data.data.device.activity_order)
          instance.$store.commit('setRowsOrder', response.data.data.device.rows_order);
          instance.$store.commit('setPinVisible', response.data.data.device.pin_visible);
          instance.$store.commit('setDarkMode', response.data.data.device.dark_mode);
          // instance.$store.commit('setRowsAsButtons', response.data.data.device.rows_as_buttons);
          instance.$store.commit('setTeamsOrder', response.data.data.device.teams_order);
          instance.$store.commit('setTeamsAsButtons', response.data.data.device.teams_as_buttons);
        }
      }

      return Promise.resolve(instance.$store.state.currentDevice);
    })
    .catch((err) => {
      if (err && err.device) return Promise.resolve(err.device)
      if (err.response) instance.$store.dispatch('setError', err.response.statusText);
      if (instance.$store.getters.debug) writeLog('Sync failed: ' + JSON.stringify(err.response));
    });
};
